import React from "react";
import { useSelector } from "react-redux";
import { useGlobalContext } from "store/contexts/globalContext";
import Loader from "components/Loader";
import DefaultTeamAvatar from "assets/img/HandsColorAvatar.jpeg";
import Scrollbar from "react-scrollbars-custom";
import classNames from "classnames";
import { ReactComponent as TeamIcon } from "assets/img/icons/team_d.svg";

function SidebarSearchFilter({ selectSearchFilter, searchWithinTeam }) {
  const { loading } = useGlobalContext();
  const { teams } = useSelector((state) => state.teamsReducer);

  return (
    <div className="searchSidebar">
      <div className="searchfilterHeading">Filters By Team</div>
      <Scrollbar
        translateContentSizeYToHolder={true}
        disableTracksWidthCompensation={true}
        removeTracksWhenNotUsed={true}
        className={"searchFilterScrollBar"}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          {loading && <Loader />}
        </div>
        {!loading && (
          <div className="allFilteredTeams">
            <span
              onClick={() => searchWithinTeam("All")}
              className={classNames({
                filterTeam: true,
                selectSearchFilter: selectSearchFilter === "All" ? true : false,
              })}
            >
              <TeamIcon className="teamAvatar" />
              All
            </span>
            {teams?.map((team) => (
              <span
                onClick={() => searchWithinTeam(team?.id)}
                key={team?.id}
                className={classNames({
                  filterTeam: true,
                  selectSearchFilter:
                    selectSearchFilter === team?.id ? true : false,
                })}
              >
                <img
                  src={team?.avatar ?? DefaultTeamAvatar}
                  alt={"avatar"}
                  className="teamAvatar"
                />
                {team?.name}
              </span>
            ))}
          </div>
        )}
      </Scrollbar>
    </div>
  );
}

export default SidebarSearchFilter;
